module.exports = __webpack_public_path__ + "img/pascual-cervera.366deadd.png";